import type { TZMap } from '@@partner:types:app'

export const TIMEZONE_OFFSETS_MAP: TZMap = {
  'UTC+02:00': 7200,
  'UTC+03:00': 10800,
  'UTC+04:00': 14400,
  'UTC+05:00': 18000,
  'UTC+06:00': 21600,
  'UTC+07:00': 25200,
  'UTC+08:00': 28800,
  'UTC+09:00': 32400,
  'UTC+10:00': 36000,
  'UTC+11:00': 39600,
  'UTC+12:00': 43200
}
